export default __webpack_public_path__ + "static/media/business-teamwork-join-hands-together-business-teamwork-concept (1).a34cfc54.jpg";